import PropTypes from 'prop-types';
import React from 'react';
import poShape from 'types/purchaseOrder';
import styles from './styles.scss';

const renderAll = (purchaseOrders, className) =>
  <span>
    {purchaseOrders.map(po =>
      <div className={className} key={po.id}>{po.kind}: {po.number}</div>,
    )}
  </span>;

const PurchaseOrders = ({ purchaseOrders, all, type, className }) => {
  const cn = `${styles.PurchaseOrder} ${className}`;
  if (all) return renderAll(purchaseOrders.filter(po => po.id >= 0), cn);
  const po = purchaseOrders.find(p => p.kind === type);
  return (
    <span className={cn}>{po && po.number}</span>
  );
};

PurchaseOrders.defaultProps = {
  all: false,
  type: 'Original',
  className: '',
};

PurchaseOrders.propTypes = {
  all: PropTypes.bool,
  type: PropTypes.string,
  purchaseOrders: PropTypes.arrayOf(PropTypes.shape(poShape)).isRequired,
  className: PropTypes.string,
};

export default PurchaseOrders;



// WEBPACK FOOTER //
// ./client/app/shared/components/PurchaseOrders/index.jsx